import React from 'react';
import { useSelector } from 'react-redux';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useQuery } from 'react-query';
import PropTypes from 'prop-types';
import ApiService from '../../services/ApiService';
import AuthService from '../../services/AuthService';
import FlexPanel from '../FlexPanel';
import { modal } from '../modal/ModalEmitter';
import { getCustomerName } from './util';

const ProspectiveList = ({ toolbar }) => {
  const { user } = useSelector(state => state.app);
  const { isLoading, data } = useQuery('prospects', async () => {
    const { data } = await ApiService.get('crm/customers');
    return data;
  });

  const handleNewQuote = customerId => {
    modal.open('quickCreate', {
      presets: {
        customer: customerId,
        assignee: user.id,
      },
    });
  };

  return (
    <FlexPanel header="Prospective Customers" toolbar={toolbar}>
      <div className="quote-list">
        {isLoading === true ? (
          <div />
        ) : (
          <table>
            <tbody>
              {data.map(customer => {
                const customerName = getCustomerName(customer);
                const name = AuthService.hasPermission('EQS5') ? (
                  <a href={`/EQS5/${customer.itemid}/edit`}>{customerName}</a>
                ) : (
                  customerName
                );
                return (
                  <tr key={customer.itemid}>
                    <td>
                      <div className="text-nowrap">{name}</div>
                    </td>
                    <td>
                      {customer.Contact}
                      {customer.Phone && (
                        <div className="text-nowrap">
                          <a href={`tel:${customer.Phone}`}>{customer.Phone}</a>
                        </div>
                      )}
                    </td>
                    <td>
                      <div className="actions text-right">
                        <DropdownButton id="actions" title="Actions" variant="success" alignRight>
                          <Dropdown.Item onClick={() => handleNewQuote(customer.itemid)}>Open New Quote</Dropdown.Item>
                        </DropdownButton>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </FlexPanel>
  );
};

ProspectiveList.propTypes = {
  toolbar: PropTypes.any,
};

export default ProspectiveList;
